export default "__VITE_ASSET__C1belA7G__"